import React from 'react';
import { Grid, Paper, Typography, Box, Button } from '@mui/material';
import './summaryGrid.css';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { TrendingDown, TrendingUp } from '@mui/icons-material';
import CustomButton from '../MasterComponent/Button/CustomButton';

interface SummaryItem {
  title: string;
  value: string;
  trend?: 'up' | 'down' | 'neutral';
  trendValue?: string;
  trendAmount?: string;
  description?: string;
  icon?: React.ReactNode;
  buttonLabel?: string;
  onButtonClick?: () => void;
}

interface SummaryGridProps {
  summaryData: SummaryItem[];
  currency?: string;
}

const SummaryGrid: React.FC<SummaryGridProps> = ({
  summaryData,
  currency = '$',
}) => {
  const getTrendArrow = (trend?: string) => {
   switch (trend) {
      case 'up':
        return <TrendingUp className="trendIconUp" />;
      case 'down':
        return <TrendingDown className="trendIconDown" />;
      default:
        return null;
    }
  };

  const getTrendClass = (trend?: string) => {
    switch (trend) {
      case 'up':
        return 'trendUp';
      case 'down':
        return 'trendDown';
      default:
        return 'trendNeutral';
    }
  };

  return (
    <div className="dataTransferSummary">
      <Grid container spacing={{ xs: 2, sm: 3, md: 3 }}>
        {summaryData.map((item, index) => {
          const isLastInRow = (columns: number) => (index + 1) % columns === 0;
          return (
            <Grid item xs={12} sm={6} md={4} lg={3} key={index} sx={{
              pr: {
                xs: 0,
                sm: isLastInRow(2) ? 0 : 1,
                md: isLastInRow(4) ? 0 : 1,
              },
            }}>
              <Paper className="summaryCard" elevation={2}>
                {item.icon ? (
                // RECOMMENDATION CARD layout
                <Box className="recommendationCard">
                  <Box className="recommendationHeader">
                    <div className="recommendationIcon">{item.icon}</div>
                    <Box className="recommendationTextBox">
                      <Typography className="summaryTitle" variant="body2">
                        {item.title}
                      </Typography>
                      {item.description && (
                        <Typography className="summaryDescription" variant="caption">
                          {item.description}
                        </Typography>
                      )}
                      <div className="cost-button-row">
                        <Typography className="summaryValue bold-heading" variant="h4">
                          {currency}{item.value}
                        </Typography>
                        {item.buttonLabel && (
                        <Box>
                          <CustomButton
                            buttonType="contained"
                            className="custom-button-class btn btn-primary btn-with-icon"
                            onClickHandler={item.onButtonClick ?? (() => { /* no-op */ })}
                            endIcon={<ArrowForwardIcon />}
                          >
                           {item.buttonLabel}       
                          </CustomButton>
                        </Box>
                        )}
                      </div>
                    </Box>
                  </Box>                  
                </Box>
              ) : (
                // COST CARD layout
                <>
                  <Box>
                    <Typography className="summaryTitle" variant="body2">
                      {item.title}
                    </Typography>
                    {item.description && (
                      <Typography className="summaryDescription" variant="caption">
                        {item.description}
                      </Typography>
                    )}
                  </Box>

                  <Box>
                    <Typography className="summaryValue bold-heading" variant="h4">
                      {currency}{item.value}
                    </Typography>

                    {item.trend && (item.trendValue || item.trendAmount) && (
                      <Box className="summaryTrend">
                        <div className={`d-flex ${getTrendClass(item.trend)}`}>
                          {getTrendArrow(item.trend)}
                          {item.trendValue && (
                            <Typography variant="body2" className="trendValue">
                              {item.trendValue}
                            </Typography>
                          )}
                        </div>
                        {item.trendAmount && (
                          <Typography variant="body2" className="trendAmount">
                            {currency}{item.trendAmount}
                          </Typography>
                        )}
                      </Box>
                    )}
                   </Box>
                </>
              )}
              
            </Paper>
          </Grid>
          );
        })}
      </Grid>
    </div>
  );
};

export default SummaryGrid;
